import * as types from 'modules/selfServices/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsDownloadingState */

/** @type {IsDownloadingState} */
const initialState = false;

const isStarted = () => true;

const isEnded = () => false;

export default createReducer(initialState, {
  [types.FETCH_SUMMARY_PDF]: isStarted,
  [types.FETCH_SUMMARY_PDF_SUCCESS]: isEnded,
  [types.FETCH_SUMMARY_PDF_FAILURE]: isEnded,
});
